<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg3 pr-6 pl-6>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedStartDateFormatted"
                    label="Từ ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="fa-calendar-alt"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex lg3 pr-6>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedEndDateFormatted"
                    label="Đến ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="fa-calendar-alt"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex lg2 pr-6><v-select
              label="Trạng thái"
              :items="status_list"
              v-model="selectedStatus"
              item-text="name"
              item-value="value"
              clearable
            ></v-select>
        </v-flex>
        <v-flex lg2 pr-6>
            <v-select
              label="Thanh toán"
              :items="payment_status"
              v-model="selectedPaymentStatus"
              item-text="name"
              item-value="value"
              clearable
            ></v-select>
        </v-flex>
        <v-flex lg2 pr-6>
            <v-btn @click="filter_data" color="#1977ff" outlined>Xem</v-btn>
        </v-flex>
        <v-flex lg12>
            <v-data-table hide-default-footer :headers="headers" :items="items" :server-items-length="items.length" :must-sort="true"  :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.ReportDate | display_date('DD-MM-YYYY')}}</td>
                        <td class="text-end">{{ item.TotalCode | currency}}</td>
                        <td class="text-end">{{ item.TotalPack | currency}}</td>
                        <td class="text-end">{{ item.TotalSmallPack | currency}}</td>
                        <td class="text-end">{{ item.TotalWeight | currency('',2)}}</td>
                        <td class="text-end">{{ item.TotalVolume | currency('',2)}}</td>
                        <td class="text-end">{{ item.TotalAmount | currency('',2)}}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr>
                        <td class="font-weight-bold">TỔNG</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalCode | currency}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalPack | currency}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalSmallPack | currency}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalWeight | currency('',2)}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalVolume | currency('',2)}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalAmount | currency('',2)}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        return {
            pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "thong-ke-lo-hang",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            status_list: configs.BIG_PACKAGE_STATUS,
            payment_status: [{value: 0, name: 'Chưa TT', color: 'red'}, {value: 1, name: 'Đã TT', color:'black'}],
            selectedStatus: null,
            selectedPaymentStatus: null
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.report.consigmentReport.data,
            loading: state => state.report.loading
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        roleAdmin() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        dic_summary() {
            return {
                'TotalCode': _.sumBy(this.items, 'TotalCode'),
                'TotalPack': _.sumBy(this.items, 'TotalPack'),
                'TotalSmallPack': _.sumBy(this.items, 'TotalSmallPack'),
                'TotalWeight': _.sumBy(this.items, 'TotalWeight'),
                'TotalVolume': _.sumBy(this.items, 'TotalVolume'),
                'TotalAmount': _.sumBy(this.items, 'TotalAmount'),
            };
        },
        headers() {
            return [
                {
                    text: "Ngày",
                    value: "ReportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Tổng lô",
                    value: "TotalCode",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng mã",
                    value: "TotalPack",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng kiện",
                    value: "TotalSmallPack",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng cân",
                    value: "TotalWeight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng khối",
                    value: "TotalVolume",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền",
                    value: "TotalAmount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                }
            ];
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                pagination: {
                        sortDesc: this.pagination.sortDesc,
                        sortBy: this.pagination.sortBy
                    }
            };
            if(this.selectedStatus != null) {
                param.status = this.selectedStatus;
            }
            if(this.selectedPaymentStatus != null) {
                param.payment_status = this.selectedPaymentStatus;
            }
            this.$store.dispatch("report/getConsigmentReport", param);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>